/**
 * Billing account catalog subview — the customer's device/feature catalog
 * matrix. Routed at `/billing/accounts/:accountId/catalog`.
 *
 * Contains:
 * - AccountCatalogView — routed child page (default export)
 */
import React from 'react';

import CustomerCatalogMatrix from '@sophocles/components/CustomerCatalogMatrix';
import SalesProvider from '@sophocles/providers/SalesProvider';
import { useBillingAccount } from '@sophocles/views/billing/BillingAccountLayout';

function AccountCatalogView() {
  const { account } = useBillingAccount();

  return (
    <SalesProvider>
      <CustomerCatalogMatrix customerId={account?.customer?.id} />
    </SalesProvider>
  );
}

export default AccountCatalogView;
